<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="title"
    [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <h3 class="default-spacing-title titulo-geral" style="color: var(--tom-2-informativo);">Perguntas frequentes</h3>

  <div class="default-spacing-title">
    <div class="search-bar-line-bg">
    <lib-segov-sigepo-rounded-search-bar
      [style]="'width: 100%; max-width: 1020px; padding: 0 2rem;'"
      [customSearchIconStyle]="'color: var(--tom-2-informativo); font-size: x-large'"
      [clearInput] = "apagarTexto"
      [customInputStyle]="'height: 64px;'"
      [placeholder]="'Digite o assunto da sua dúvida'"
      [hasSideIcon]="efetouPesquisa"
      [iconeCustom]="'icons/close-circle-line-laranja.svg'"
      (TextChanged)="AtualizaTexto($event)"
      (ClickedFilter)="PesquisarPerguntasFrequentes()"
      (keyup.enter)="PesquisarPerguntasFrequentes()"
      (ClickedClear)="ReiniciarPesquisa()"></lib-segov-sigepo-rounded-search-bar>
      @if(errorMsg){
        <p class="error-message text-center mt-2">{{errorMsg}}</p>
      }
    </div>

    @if(totalRegistros) {
      <h4 class="my-4 text-center">Foram encontrados <strong style="color: var(--tom-2-jornal)">{{totalRegistros}}</strong> resultados</h4>
    }

    <div style="width: 100%; padding-top: 1rem;">
      <lib-segov-sigepo-side-menu-with-body
      (arquivoParaBaixar)="baixarArquivoSelecionado($event)"
      (topicoOutput)="scrollToIdByResolution($event)"
      [showCustomContent]="true"
      [menuTopicsSelectedItemOnStartInput]="finalizouNovaPesquisa"
      [menuItems]="ItemsMenuPerguntasFrequentes"></lib-segov-sigepo-side-menu-with-body>
    </div>
  </div>

  <div class="exibe-tela-maior-993" style="width: 100%; align-self: center; padding: 2rem 25%">
    <div class="row">
      <div class="col-md-1 col-12">
        <img src="icons/question-line.svg" width="48px" alt="Ícone de interrogação." />
      </div>
      <div class="col-md-8 col-12">
        <h5 style="font-weight: 600;">Não encontrou o que procurava? <br>Envie sua mensagem!</h5>
        <p>Acesse o nosso contato e envie sua dúvida para que a nossa equipe possa auxiliar você!</p>

      </div>
      <div class="col-md-3 col-12" style="align-self: center;">
        <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [type]="'button'"
          [customStyle]="'border-radius: 5px;'"
          (click)="goToAtendimento()" (keyup.enter)="goToAtendimento()">
          Envie sua dúvida
        </lib-segov-sigepo-rounded-button>
      </div>
    </div>

  </div>

</app-segov-sigepo-portal-body>
